import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { useNavigate, useParams } from 'react-router-dom';
import { getProjectById } from '../../Services/PtaasApiService';
import Phase from '../../Models/Phase';
import PhaseRow from './Rows/PhaseRow';
import Project from '../../Models/Project';
import { LoaderIcon } from '../Global/Icons';



const PhaseList: React.FC = () => {
  const navigate = useNavigate();
  const { id,canopyid } = useParams();
  const { instance, accounts } = useMsal();
  const [phases, setPhases] = useState<Phase[]>(null);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    async function fetchProject(): Promise<void> {
         setLoading(true);
      let returnedProject: Project;
      try { returnedProject = await getProjectById(id,parseInt(canopyid), instance, accounts[0]) }
      catch (error) {
        console.error("Error fetching project:", error);
      }
      setPhases(returnedProject?.phases)
      setLoading(false);
    }
    fetchProject();
  }, [navigate, canopyid, instance, accounts,id]);
  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
     < LoaderIcon/>
      </div>
    );
  }

  return (
    <div className='border my-4'>
      <Table className='m-0 table-info'>
        <tbody>
          {phases?.map(phase => <PhaseRow key={phase.id} phase={phase} />)}
        </tbody>
      </Table>
    </div>
  );
};

export default PhaseList;